// src/store/projectStore.js
import { create } from 'zustand';
import { api } from '../lib/api';

export const useProjectStore = create((set, get) => ({
  projects: [],
  loading: false,

  fetchProjects: async () => {
    set({ loading: true });
    try {
      const projects = await api.get('/projects');
      set({ projects, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  addProject: async (projectName) => {
    const created = await api.post('/projects', { name: projectName });
    set((state) => ({ projects: [created, ...state.projects] }));
  },

  renameProject: async (id, newName) => {
    const updated = await api.put(`/projects/${id}`, { name: newName });
    set((state) => ({
      projects: state.projects.map((p) => (p.id === id ? updated : p)),
    }));
  },

  deleteProject: async (id) => {
    await api.del(`/projects/${id}`);
    set((state) => ({
      projects: state.projects.filter((p) => p.id !== id),
    }));
  },

  archiveProject: async (id, archived) => {
    const updated = await api.patch(`/projects/${id}/archive`, { archived });
    set((state) => ({
      projects: state.projects.map((p) => (p.id === id ? updated : p)),
    }));
  },
}));
